import type { Tier } from "@/scripts/review-ledger"

// Tier chips + per-string badges share one label/marker source. `new` never
// reaches the cockpit queue (it's a CI-only tier), so it isn't listed here.
// Shared by the desktop worklist and the mobile review view.
export const TIER_LABEL: Partial<Record<Tier, string>> = {
  legal: "⚖ legal",
  glossary: "📖 glossary",
  "high-traffic": "⬆ high traffic",
}
export const TIER_MARKER: Partial<Record<Tier, string>> = {
  legal: "⚖",
  glossary: "📖",
  "high-traffic": "⬆",
}
// Accessible text for the emoji tier chips/markers so they aren't emoji-only for
// screen readers (the emoji itself carries the meaning visually).
export const TIER_ARIA: Partial<Record<Tier, string>> = {
  legal: "Legal tier",
  glossary: "Glossary tier",
  "high-traffic": "High-traffic tier",
}
// Order tier chips legal → glossary → high-traffic (precedence order).
export const TIER_ORDER: Tier[] = ["legal", "glossary", "high-traffic"]
